import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { TimeSchedule } from '../work-schedule'
import { BehaviorSubject } from 'rxjs'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { FormsModule } from '@angular/forms'
import { MatSlider, MatSliderThumb } from '@angular/material/slider'
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatDialogClose } from '@angular/material/dialog'
import { MatIconButton, MatButton } from '@angular/material/button'
import {
  ElderThemeDirective,
  ElderLocalTimeInputComponent,
  ElderValidationErrorDirective,
} from '@elderbyte/ngx-starter'
import { MatToolbar } from '@angular/material/toolbar'

@Component({
  selector: 'app-time-schedule-slot-edit',
  templateUrl: './time-schedule-slot-edit.component.html',
  styleUrls: ['./time-schedule-slot-edit.component.scss'],
  imports: [
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    MatFormField,
    MatLabel,
    ElderLocalTimeInputComponent,
    MatError,
    ElderValidationErrorDirective,
    MatSlider,
    FormsModule,
    MatSliderThumb,
    MatButton,
    ElderTranslatePipe,
  ],
})
export class TimeScheduleSlotEditComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly slot$ = new BehaviorSubject<TimeSchedule>(null)

  @Output()
  public close: EventEmitter<Event> = new EventEmitter<Event>()

  @Output()
  public save: EventEmitter<Event> = new EventEmitter<Event>()

  @Output()
  public delete: EventEmitter<Event> = new EventEmitter<Event>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set slot(slot: TimeSchedule) {
    this.slot$.next(slot)
  }

  public get slot(): TimeSchedule {
    return this.slot$.getValue()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public formatLabel(value: number): string {
    return Math.floor(value * 100) + '%'
  }

  /***************************************************************************
   *                                                                         *
   * Component Events                                                        *
   *                                                                         *
   **************************************************************************/

  public onDelete(event: Event): void {
    this.emitDelete(event)
  }

  public onSave(event: Event): void {
    this.emitSave(event)
  }

  public onClose(event: Event): void {
    this.emitClose(event)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private emitDelete(event?: Event): void {
    this.delete.emit(event)
  }

  private emitSave(event?: Event): void {
    this.save.emit(event)
  }

  private emitClose(event?: Event): void {
    this.close.emit(event)
  }
}
